import { usePageTracking } from '../../hooks/usePageTracking';

/**
 * Component to track page views across the application
 * This component doesn't render anything, it just handles tracking
 */
export const PageTracker: React.FC = () => {
    usePageTracking();
    return null;
};

export default PageTracker;